<!-- 工单管理 -->
<template>
    <div class="index-main">
        <a-row style="height: 100%;positive: relative">
            <a-col :span="6" class="cell-left">
                <a-row style="height: 100%">
                    <!-- <a-col :span="24" style="height: 25%">
                        <workOrderBaseInfo ref="workOrderBaseInfoRef"></workOrderBaseInfo>
                    </a-col>
                    <a-col :span="24" style="height: 35%">
                        <workOrderRealTime ref="workOrderRealTimeRef"></workOrderRealTime>
                    </a-col> -->
                    <a-col :span="24" style="height: 55%">
                        <SatisfactionLevel ref="SatisfactionLevelRef"></SatisfactionLevel>
                    </a-col>
                    <a-col :span="24" style="height: 45%">
                        <workOrderBusinessTrends ref="workOrderBusinessTrendsRef"></workOrderBusinessTrends>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="12" style="height: 100%;">
                <a-row style="height: 100%;margin-left: 5px;margin-right: 5px">
                  <a-col :span="24" style="height: 40%">
                      <WorkOrderCenter ref="WorkOrderCenterRef" />
                  </a-col>
                  <a-col :span="24" style="height: 60%">
                      <workOrderRealTime ref="workOrderRealTimeRef" />
                  </a-col>
                </a-row>
            </a-col>
            <a-col :span="6" class="cell-right">
                <a-row style="height: 100%">
                    <a-col :span="24" style="height: 32%">
                      <workOrderProcessingProgress ref="workOrderProcessingProgressRef" :titleImage="titleImage"/>
                    </a-col>
                    <a-col :span="24" style="height: 34%">
                      <WorkOrderConstitute ref="WorkOrderConstituteRef" :titleImage="titleImage"/>
                    </a-col>
                    <a-col :span="24" style="height: 34%">
                      <WorkOrderSource ref="WorkOrderSourceRef" :titleImage="titleImage"/>
                    </a-col>
                </a-row>
            </a-col>
        </a-row>
    </div>
</template>
<script>
// import workOrderBaseInfo from './modules/workOrderBaseInfo'
import workOrderRealTime from './modules/workOrderRealTime'
import workOrderBusinessTrends from './modules/workOrderBusinessTrends'
// import echartMap from './modules/echartMap'
import WorkOrderCenter from './modules/WorkOrderCenter'
import workOrderProcessingProgress from './modules/workOrderProcessingProgress'
import WorkOrderConstitute from './modules/WorkOrderConstitute'
import WorkOrderSource from './modules/WorkOrderSource'
import SatisfactionLevel from './modules/SatisfactionLevel'
export default {
    components: {
        // workOrderBaseInfo,
        workOrderRealTime,
        workOrderBusinessTrends,
        WorkOrderCenter,
        workOrderProcessingProgress,
        WorkOrderConstitute,
        WorkOrderSource,
        SatisfactionLevel
    },
    data() {
        return {
            titleImage:require("@/assets/images/title-gradual.png"),
        }
    },
    mounted() {
        this.$nextTick(()=> {
            this.init()
        })
    },
    methods: {
        init() {
            // this.$refs.workOrderBaseInfoRef.init()
            this.$refs.workOrderRealTimeRef.init()
            this.$refs.workOrderBusinessTrendsRef.init()
            this.$refs.workOrderProcessingProgressRef.init()
            this.$refs.WorkOrderConstituteRef.init()
            this.$refs.WorkOrderSourceRef.init()
            this.$refs.WorkOrderCenterRef.init()
            this.$refs.SatisfactionLevelRef.init()
        }
    }
}
</script>
<style lang="less" scoped>
.index-main{
    height: 100%;
    padding: 12px;
}
.cell-left,.cell-right{
    height: 100%;
    padding-left: 12px;
    padding-right: 12px;
    //position: absolute;
}
.cell-bottom{
    height: 30%;
    //position: absolute;
    background: url('~@/assets/images/cell-bottom.png') no-repeat;
    background-size: 100% 100%;
}
.cell-left{
    top: 0;
    left: 0;
}
.cell-right{
    top: 0;
    right: 0;
}
.cell-bottom{
    bottom: 0;
    height: 30%;
}
/* 每块内容的样式 */
.index-main{
    /deep/ .m-panel{
        color: #B6DEFF;
        height: 100%;
    }
    /deep/ .m-panel-bar{
        height: 40px;
    }
    /deep/ .m-panel-bar-title{
        font-size: 18px;
        font-weight: 700;
        color: #B6DEFF;
        display: flex;
        align-items: center;
        padding-left: 7px;
        border-bottom: 5px solid transparent; /* 创建透明的下边框 */
        border-image: url('~@/assets/images/title-gradual.png') 5 stretch; /* 指定图像路径、重复次数和对齐方式 */
        border-image-repeat: stretch;
    }
    /deep/ .m-panel-body{
        height: calc(100% - 40px)
    }
    /deep/ .total-sum{
        color: #A8C6F3;
        font-weight: bold;
        font-size: 33px;
        margin-top: 33px;
    }
    /deep/ .unit{
        font-size: 12px;
        color: #A8C6F3;
        margin-left: 5px;
    }
    /deep/ .m-total{
        padding: 10px;
        line-height: 1;
        
        .total-title{
            color: #01B8FD;
            font-weight: 500;
            font-size: 16px;
        }
        .total-type-title{
            color: #B6DEFF;
        }
    }
    /deep/ .font-24{
        font-size: 24px;
    }
    /deep/ .flex-center{
        display: flex;
        align-items: center;
    }
}
.cell-left{
    position: relative;
    background: url('~@/assets/images/cell-left.png') no-repeat;
    background-size: 100% 100%;
}
.cell-right{
    position: relative;
    background: url('~@/assets/images/cell-right.png') no-repeat;
    background-size: 100% 100%;
}
</style>